declare var BASE_URL:string;
declare var STATIC_BASE_URL:string;

import '../styles/products.scss';
import '../styles/frames.scss';
import '../styles/aisociallab.scss';

import { h, Component } from 'preact';

export default class Aisociallab extends Component<any, any> {

    constructor() {
        super();
    }

    public render (props, state): any {
      
      const calltoaction = <p class="center calltoaction"><a href="https://www.bitlanders.com" target="_blank" class="butt huge">Register</a></p>;

        return <div id="aisociallab" class="product">
          <div class="mainWrp">
            <section class="body center">
              <h1>AI Social Lab</h1>
              <h2 class="content">
                Want to immerse in an AI community?<br />
                Want to crowd source your AI project?​
              </h2>
              { calltoaction }
            </section>
          </div>
          <div class="mainWrp frameWrp">
            <div class="col">
              <div class="frame ipad">
                <img class="frameImg" src={STATIC_BASE_URL + 'images/public/frame_ipad.png'} alt="AI Social Lab" />
                <div class="inframeWrp">
                  <img class="inframe" src={ STATIC_BASE_URL + 'images/public/products-ai-social-lab-detail.png'} alt="AI Social Lab" />
                </div>
              </div>
            </div>
            <div class="col padLeft">
              <h2>Join Bitlanders, the world's top AI community!</h2>
              <p>
                The AI Social Lab is the ideal place for both Business and Individuals.</p>
              <p>
                As an Individual, it's the place to chill with other AI peers, a community where you can learn AI related knowledge and brush up your skills, while participating in various AI projects and earn money!</p>
              <p>
                For business, it's the place to have your AI projects launched and your NLU models trained!​
              </p>
            </div>
            <br style="clear:both" />
          </div>
          <section class="full grey">
              <p>For companies, you would need a good crowd sourcing place for fast and high-quality delivery of your AI projects. AI, Natural Language Understanding and machine learning are few of today's most important technologies.
              </p>​
              <p>For individuals, you will study AI applications and complete AI projects that will influence you to rethink everything you know about the meaning and purpose of work and life. New AI technologies are being introduced at an incredibly rapid pace and keeping up can be challenging. Our AI social lab will keep you on the loop in AI research and development to truly understand all the implications these evolving techologies  will have for our world.​
              </p>
          </section>
          
          <section>
            <blockquote>
              Artificial Intelligence is like water, sooner or later we all need to drink it or use it to put out fires.​
              <span>Francesco Rulli, President and founder of Querlo</span>
            </blockquote>
          </section>
  
          <section class="features center cols full">
            <div class="mainWrp">
              <h2>Benefits for individuals</h2>
              <div class="col">
                <div class="col first">
                  <h3><i class="fa fa-swatchbook"></i> Gain AI Education</h3>
                  <p>
                    Expand your knowledge of AI and receive our certificate. We provide various training and tutorial material.
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-undo-alt"></i> Earn real money</h3>
                  <p>
                    Dive in to start an AI career and earn real money rewards. By producing quality work you will get paid while becoming an AI expert. ​
                  </p>
                </div>
              </div>
              <div class="col">
                <div class="col">
                  <h3><i class="fa fa-grin-hearts"></i> Create your own AI content</h3>
                  <p>
                    Produce quality interactive content for your c-blogs, the first conversational AI blogging. This will establish a conversational relationship with your readers. ​
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-brain"></i> Become AI specialist</h3>
                  <p>
                    Make yourself an expert in AI, the blooming industry. You will have the opportunity to help other users explore AI applications to real projects.
                  </p>
                </div>
              </div>
            </div>
          </section>
  
          <section class="features doublecol full center cols grey">
            <h2>Features</h2>
            <div class="mainWrp">
              <div class="col">
                <h2>For businesses</h2>
                <h3><i class="fa fa-users"></i> Large user base</h3>
                <p>
                  There are more than 1 million users at the AI Social Lab community, the longest ones have been with us for 5 years.​
                </p>
                <h3><i class="fa fa-crown"></i> Gamified rewarding</h3>
                <p>
                  We have a patent peer reviewing system where quality deliverables will earn more rewards.​
                </p>
                <h3><i class="fa fa-rocket"></i> Crowd sourcing</h3>
                <p>
                  Collectively contribute ideas, information and collaborative knowledge to engage the community for better quality and efficiency.​
                </p>
              </div>
              <div class="col">
                <h2>For individuals</h2>
                
                <h3><i class="fa fa-money-bill"></i> Crypto currency payment</h3>
                <p>
                  Our patent rewarding system pays user in bitMiles, redeemable into real money.
                </p>
                <h3><i class="fa fa-users"></i> Community environment</h3>
                <p>
                  The community environment will offer support where you can also gain relationships. You will find the opportunity to form an educational, innovative and influential community exclusively on AI.
                </p>
                <h3><i class="fa fa-mobile-alt"></i> App version</h3>
                <p>
                  Our Machine Learning Training project has launched its app version so users can participate in AI anytime anywhere.
                </p>
              </div>
            </div>
          </section>
          
          <section>
            <p>
              <img class="mlt" src={ STATIC_BASE_URL + 'images/public/icons/MLT.png' } alt="Machine Learning Training" />
            </p>
            <h2>Machine Learning Training</h2>
            <p>
              The biggest challenge for any NLU project is to gain a large amount of high-quality training data within your budget. Bitlanders is an innovative AI community responsible for training your NLU models, making sure your machine can understand human expressions and constantly learn and adapt through experiences.
            </p>
            <p>
              The app version of our Machine Learning Training allows users to stay connected at all time and improve your machine anytime, anywhere. With our large user base, we have fast delivery in our training processes. BitLanders's user base is broadly varied, allowing us to provide Machine Learning Training in various languages, such as English, Arabic, Spanish, Chinese, Italian, and many more. We have a patent rewarding methodology to ensure the AI community is highly motived and is producing quality work.
            </p>
            <p class="downloads">
              <a href="https://play.google.com/store/apps/details?id=com.mti.mlt" target="_blank">
                <img src={ STATIC_BASE_URL + 'images/public/icons/store_play.png' } alt="Download from Play Store" />
              </a>
              <a href="https://itunes.apple.com/app/querlo-mlt/id1453150979" target="_blank">
                <img src={ STATIC_BASE_URL + 'images/public/icons/store_app.png' } alt="Download from App Store" />
              </a>
            </p>
          </section>
          
          <section class="full grey">
            { calltoaction }
          </section>
        </div>
    }
}


// WEBPACK FOOTER //
// ./ts/Aisociallab.tsx